<template>

    <div class="row">
        <div class="col-lg-4">
            <div class="box box-solid">
                <div class="box-header">
                    <h2 class="box-title">Geregistreerde uren ({{ totalHours }} uur)</h2>
                    <div class="box-tools pull-right">
                        <json-excel
                            :data="getExcelData"
                            :fields="getExcelFields"
                            :name="getExportName()"
                            class="btn btn-default btn-sm"
                            v-tooltip="'Exporteer naar Excel'"
                        >
                            <i class="mdi mdi-file-excel-box"></i>
                        </json-excel>
                        <button
                            class="btn btn-default btn-sm"
                            @click="exportToPdf()"
                            v-tooltip="'Exporteer naar PDF'"
                        >
                            <i class="mdi mdi-file-pdf-box"></i>
                        </button>
                    </div>
                </div>
                <div class="box-body no-padding">
                    <table class="table table-striped table-hover" id="project-hours-table">
                        <thead>
                            <tr>
                                <th>Taak</th>
                                <th>Uren/Goedgekeurd</th>
                                <th v-if="canFinance">Budget</th>
                            </tr>
                        </thead>
                        <tbody v-if="tasks.length === 0">
                            <tr>
                                <td colspan="3">Er zijn nog geen taken aan dit project gekoppeld</td>
                            </tr>
                        </tbody>
                        <tbody v-for="task in tasks">
                            <tr>
                                <th v-if="projectUuid !== null">
                                    <router-link :to="{name:'projects.details.tasks', params:{uuid:projectUuid,task_uuid:task.uuid}}">{{ task.name }}</router-link>
                                </th>
                                <th v-else>{{ task.name }}</th>

                                <th>{{ task.total_hours }} ({{ task.total_accepted_hours }})</th>
                                <th v-if="canFinance">{{ task.budget | toCurrency }}</th>
                            </tr>
                            <tr v-for="costcode in task.costcodes">
                                <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ costcode.label }}</td>
                                <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ costcode.total_hours }} ({{ costcode.total_accepted_hours }})</td>
                                <td v-if="canFinance">&nbsp;</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="col-lg-8">
            <div class="box box-solid">
                <div class="box-header">
                    <h2 class="box-title">Uren goedkeuren ({{ totalUnacceptedHours }} uur)</h2>
                </div>
                <div class="box-body no-padding">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th>Gebruiker</th>
                                <th>Taak</th>
                                <th>Kostcode</th>
                                <th>Datum</th>
                                <th class="text-center">Uren</th>
                                <th class="text-right">Goedkeuren?</th>
                                <th v-if="canAdmin">&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="records.data.length === 0"><td colspan="6">Er zijn geen uren om goed te keuren</td></tr>
                            <tr v-for="record in records.data" :class="{'declined':record.declined}">
                                <td>{{ record.user }}</td>
                                <td>{{ record.task }}</td>
                                <td>{{ record.costcode }}</td>
                                <td>{{ record.date }}</td>
                                <td class="text-center">{{ record.hours }}</td>
                                <td class="text-right timeregistration-container">
                                    <i
                                        v-if="record.description !== null && record.description !== ''"
                                        class="mdi mdi-format-quote-open pull-left"
                                        v-tooltip="record.description.replace('\n','<br />')"
                                    ></i>
                                    <bootstrap-toggle
                                        v-model="record.checked"
                                        :disabled="record.declined"
                                        :options="{on:'Ja',off:'Nee',size:'mini'}"
                                    ></bootstrap-toggle>
                                    <div
                                        v-if="!record.checked && !record.declined"
                                        class="timeregistration-message-box text-left"
                                    >
                                        <div class="form-group">
                                            <label>Afkeurbericht</label>
                                            <textarea
                                                v-model="record.declinedmessage"
                                                class="form-control"
                                            ></textarea>
                                        </div>
                                        <div class="text-right">
                                            <div class="btn-group btn-group-sm">
                                                <button class="btn btn-danger"
                                                    @click="record.checked = !record.checked"
                                                ><i class="mdi mdi-close"></i></button>
                                                <button class="btn btn-primary"
                                                    :disabled="record.declinedmessage === ''"
                                                    @click="declineRecord(record)"
                                                ><i class="mdi mdi-check-bold"></i></button>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td
                                    v-if="canEditHours"
                                    class="text-right"
                                >
                                    <button
                                        class="btn btn-default btn-xs"
                                        v-tooltip="'Uren bewerken'"
                                        @click="editRecord(record)"
                                    >
                                        <i class="mdi mdi-pencil"></i>
                                    </button>
                                </td>
                            </tr>
                            <tr v-if="records.data.length > 0">
                                <td colspan="7" class="text-right">
                                    <button class="btn btn-primary btn-sm" @click="process()">Opslaan</button>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot v-if="remainingRecords > 0">
                            <tr>
                                <td colspan="7" class="text-center">Er zijn nog {{ remainingRecords }} andere uren om goed te keuren</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
                <div class="overlay" v-if="loading || processDecline">
                    <i class="fa fa-refresh fa-spin"></i>
                </div>
            </div>
        </div>
        <div class="modal fade" id="editTimeregistrationModal" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-sm" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                            @click="closeModal"
                        >
                            <span aria-hidden="true">
                                <i class="mdi mdi-close"></i>
                            </span>
                        </button>
                        <h4 class="modal-title">Uren bewerken</h4>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <label class="control-label">{{ lang.get('global.user') }}</label>
                            <p class="form-control-static">
                                {{ form.user }}
                            </p>
                        </div>
                        <div class="form-group">
                            <label class="control-label">{{ lang.get('global.date') }}</label>
                            <p class="form-control-static">
                                {{ form.date }}
                            </p>
                        </div>
                        <div class="form-group">
                            <label class="control-label">{{ lang.get("global.project") }}</label>
                            <v-select
                                v-model="form.project_uuid"
                                :options="projects"
                                label="project_name"
                                :reduce="project => project.uuid"
                            ></v-select>
                        </div>
                        <div class="form-group" v-if="!isBureauProject">
                            <label class="control-label">{{ lang.get("tasks.task") }}</label>
                            <v-select
                                v-model="form.task_uuid"
                                :disabled="form.project_uuid === null"
                                :options="getSelectedProjectTasks"
                                :reduce="task => task.uuid"
                                label="name"
                            ></v-select>
                        </div>
                        <div class="form-group">
                            <label class="control-label">{{ lang.get("timeregistration.costcode") }}</label>
                            <v-select
                                v-model="form.costcode_id"
                                :disabled="!isBureauProject && selectedTask === null"
                                :options="getSelectedTaskCostcodes"
                                :reduce="costcode => costcode.id"
                            ></v-select>
                        </div>
                        <div class="form-group">
                            <label class="control-label">{{ lang.get('global.hours') }}</label>
                            <input
                                type="text"
                                class="form-control"
                                maxlength="4"
                                pattern="[0-9]+([\.,][0-9]+)?"
                                step="any"
                                min="0"
                                v-model="form.hours"
                            />
                        </div>
                        <div class="form-group">
                            <label class="control-label">{{ lang.get('global.description') }}</label>
                            <textarea
                                v-model="form.description"
                                class="form-control"
                            ></textarea>
                        </div>
                        <div class="text-right">
                            <button
                                class="btn btn-primary btn-sm"
                                @click="onEditSubmit"
                                :disabled="posting === true || !canEditHours"
                            >
                                Uren bewerken
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

import axios from 'axios';
import BootstrapToggle from 'vue-bootstrap-toggle';
import jsPDF from 'jspdf';
import JsonExcel from 'vue-json-excel';
import {mapActions,mapGetters} from "vuex";
import vSelect from 'vue-select';
import Lang from "../../Lang";
import moment from "moment";
import striptags from 'striptags';

export default {

    components: {
        BootstrapToggle,
        JsonExcel,
        vSelect,
    },

    computed: {

        ...mapGetters([
            'dataLoaded',
            'getRoutes',
        ]),

        canEditHours() {
            return this.canAdmin || this.cuh === true;
        },

        getExcelData() {
            let data = [];
            this.tasks.forEach(task => {
                data.push({
                    name:task.name,
                    costcode:"",
                    total_hours:task.total_hours,
                    total_accepted_hours: task.total_accepted_hours,
                    budget: task.budget,
                });
                task.costcodes.forEach(costcode => {
                    data.push({
                        name:"",
                        costcode:costcode.label,
                        total_hours:costcode.total_hours,
                        total_accepted_hours: costcode.total_accepted_hours,
                        budget:"",
                    });
                });
            });
            return data;
        },

        getExcelFields() {
            return {
                'Taak':'name',
                'Kostcode': 'costcode',
                'Totale uren': 'total_hours',
                'Geaccepteerde uren': 'total_accepted_hours',
                'Budget':'budget',
            };
        },

        postData(){
            let data = [];
            this.records.data.forEach(record => {
                if (record.checked === true) {
                    data.push(record.id);
                }
            });
            return {accept:data};
        },

        remainingRecords() {
            return this.records.total - this.records.data.length;
        },

        selectedProject() {
            if (this.projects.length === 0) {
                return null;
            }

            return this.projects.filter(project => project.uuid === this.form.project_uuid)[0];
        },

        selectedTask() {
            if (this.selectedProject === null || this.form.task_uuid === null) {
                return null;
            }

            let task = this.selectedProject.tasks.filter(task => task.uuid === this.form.task_uuid);

            return task.length > 0 ?
                task[0] :
                null;
        },

        getSelectedProjectTasks() {
            if (this.selectedProject === null) {
                return [];
            }
            return this.selectedProject.tasks;
        },

        getSelectedTaskCostcodes() {
            if (this.isBureauProject) {
                return this.costcodes;
            }
            if (this.selectedTask === null) {
                return [];
            }
            return this.selectedTask.costcodes;
        },

        isBureauProject() {
            return this.selectedProject !== null &&
                this.selectedProject.uuid === null;
        },

        getEditRoute() {
            return this.projectUuid === null ?
                this.route('api.v1.hr.timeregistration.update', {id:this.form.id}, false) :
                this.route('api.v1.projects.hours.update', {project_uuid:this.projectUuid, id:this.form.id}, false);
        },

    },

    data() {
        return {
            cuh:false,
            form:{
                project_uuid:null,
                task_uuid:null,
                costcode_id:null,
                hours:0,
                description:'',
                user:'',
                date:'',
                id:null,
            },
            lang:Lang,
            loading:true,
            posting:false,
            processDecline:false,
            records: {
                data:[],
                total:0,
            },
            tasks:[],
            totalHours:0,
            totalUnacceptedHours:0,

            // Modal
            costcodes:[],
            projects:[],
        };
    },

    methods: {
        ...mapActions([
            'parseData',
        ]),

        closeModal() {
            this.resetForm();
            $('#editTimeregistrationModal').modal('hide');
        },

        editRecord(record) {
            let data = JSON.parse(JSON.stringify(record));
            this.form.project_uuid = data.project_uuid;
            this.form.task_uuid = data.task_uuid;
            this.form.costcode_id = data.costcode_id;
            this.form.hours = data.hours;
            this.form.description = data.description;
            this.form.user = data.user;
            this.form.date = data.date;
            this.form.id = data.id;
            this.openModal();
        },

        resetForm() {
            this.form = {
                project_uuid:null,
                task_uuid:null,
                costcode_id:null,
                hours:0,
                description:'',
                user:'',
                date:'',
                id:null,
            };
        },

        openModal() {
            $('#editTimeregistrationModal').modal({
                backdrop: 'static',
                keyboard: false
            }).modal('show');
        },

        onEditSubmit() {
            if (this.posting === true || this.canEditHours !== true) {
                return;
            }

            this.posting = true;

            axios.post(this.getEditRoute, this.form)
                .then(() => {
                    this.$snotify.success('De uren zijn aangepast');
                    this.loading = true;
                    this.getTimeregistrations();
                })
                .catch(() => this.$snotify.error('Er is een fout opgetreden bij het opslaan van de uren'))
                .finally(() => {
                    this.posting = false;
                    this.closeModal();
                });
        },

        declineRecord(record) {
            this.processDecline = true;
            axios.post(record.paths.decline, {declinedmessage:striptags(record.declinedmessage)})
            .then(resp => {
                if (resp.data.success) {
                    record.declined = true;
                    this.$snotify.success("De geselecteerde uren zijn geweigerd")
                } else {
                    this.$snotify.error("Er is iets fout gegaan bij het weigeren van de uren");
                }
            })
            .catch(() => {
                this.$snotify.error("Er is iets fout gegaan bij het weigeren van de uren");
            })
            .finally(() => {
                this.processDecline = false;
            });
        },

        exportToPdf() {
            let doc = new jsPDF({orientation:'landscape'});
            doc.autoTable({html:'#project-hours-table'});
            doc.save(this.getExportName() + '.pdf');
        },

        getExportName() {
            return 'timeregistration-' + moment().format('YYYY-MM-DD-HH-mm');
        },

        getTimeregistrations() {
            axios.get(this.hoursUri)
            .then(resp => {
                this.records.data = resp.data.data;
                this.records.total = resp.data.count;
                this.tasks = resp.data.tasks;
                this.totalHours = resp.data.total_hours;
                this.totalUnacceptedHours = resp.data.total_unaccepted_hours;
                this.cuh = resp.data.cuh;
                this.loading = false;
            });
        },

        process() {
            this.loading = true;
            axios.post(this.processUri, this.postData)
            .then(() => {
                this.$snotify.success("De geselecteerde uren zijn goedgekeurd");
                this.getTimeregistrations();
            })
            .catch(() => {
                this.$snotify.error("Er is een fout opgetreden bij het opslaan van de uren");
                this.loading = false;
            })
        },

        getModalData() {
            axios.get(this.getRoutes.projectsuri, {params: {withtasks:true, withinactive:true}})
                .then(response => {
                    this.projects = response.data.data;
                    this.projects.unshift({
                        project_name:'000-Bureau',
                        name:'000-Bureau',
                        uuid:null,
                    });
                });

            axios.get(this.getRoutes.costcodes.office)
                .then(response => this.costcodes = response.data.data);
        },
    },

    mounted() {
        this.getTimeregistrations();

        if (false === this.dataLoaded) {
            this.parseData();
        } else {
            this.getModalData();
        }
    },

    name:"ProjectTimeregistration",

    props: {
        canAdmin: {
            type:Boolean,
            default:false,
        },
        canFinance: {
            type:Boolean,
            default:false,
        },
        hoursUri: {
            required:true,
            type:String,
        },
        processUri: {
            required:true,
            type:String,
        },
        projectUuid: {
            type:String,
            default:null,
        },
    },

    watch: {
        dataLoaded: function(newLoaded) {
            if (newLoaded === true) {
                this.getModalData();
            }
        },

        selectedProject: function (newSelectedProject, oldSelectedProject) {
            if (newSelectedProject === null || (oldSelectedProject !== null && oldSelectedProject.uuid && (newSelectedProject.uuid !== oldSelectedProject.uuid))) {
                this.form.task_uuid = null;
                this.form.costcode_id = null;
            }
        },
    },

}

</script>

<style>

    .timeregistration-container {
        position:relative;
    }

    .timeregistration-message-box {
        position:absolute;
        z-index:10;
        right:0;
        top:40px;
        background-color:#fff;
        border:2px solid #f0ad4e;
        border-radius:6px;
        min-width:150px;
        min-height:80px;
        padding:8px 16px;
    }

    .timeregistration-message-box textarea {
        min-width:200px;
    }

    tr.declined {
        text-decoration:line-through;
    }

</style>
